// Every operation got a "run" function which does the operation and an "invert" function that returns the inversed operation
export const add = value => ({
  run(acc) {
    return acc + value;
  },
  invert() {
    return add(-value);
  }
});

export const multiply = value => ({
  run(acc) {
    return acc * value;
  },
  invert() {
    return multiply(1 / value);
  }
});

// An operation that does nothing, called "identity" in the functional world
export const identity = {
  run(acc) {
    return acc;
  },
  invert() {
    return identity;
  }
};

// combines multiple operations, e.g. combine(add(1), multiply(2)) is (acc + 1) * 2 and can be inversed to acc / 2 + 1
export const combine = (...ops) => ({
  op(acc) {
    return ops.reduce((acc, op) => op(acc), acc);
  },
  invert() {
    return combine(...[...ops].reverse().map(it => it.invert()));
  }
});

// Represents an operation node in the tree
export const op = (key, op, ...sub) => ({ key, op, sub });

// The upmost operation
export const tree = (key, ...sub) => op(key, identity, ...sub);
